import Swiper from "swiper";
import { Autoplay, Pagination } from "swiper/modules";

export default function swiperAside() {
  const sliderElement = document.querySelector('.swiper-aside');
  if (sliderElement) {
      new Swiper('.swiper-aside', {
          modules: [Autoplay, Pagination],
          slidesPerView: 1,
          spaceBetween: 20,
          allowTouchMove: false,
          loop: false,
          autoplay: {
              delay: Number(sliderElement.dataset.swiperDelay) || 5000,
              disableOnInteraction: true,
          },
          pagination: {
            clickable: true,
            el: '.aside__container__banner .swiper-pagination',
          },
          speed: 400,
      });
  }
}
swiperAside();